// PTZ AW-RP50 — panel-orientation walkthrough.
//
// Demonstrate phase (T3-IDAC). The trainee walks through CAMERA
// SELECT, the joystick, the zoom rocker, and preset recall in
// sequence. Auto-advances on first matching action; pure look beats
// advance on Next.

import type { PTZAction } from "../../ptz-aw-rp50";
import type { WalkthroughStep } from "../../../help/help-types";

export const PTZ_AW_RP50_PANEL_ORIENTATION: WalkthroughStep[] = [
  {
    id: "intro",
    body:
      "Look at the panel. Top-left is CAMERA SELECT — the three buttons that decide which camera the rest of the controls drive. The big disc in the middle is the joystick (pan and tilt); the rocker beside it is zoom. The numbered grid on the right is the preset pad: ten stored shots you can recall with one press.",
  },
  {
    id: "select-cam",
    body:
      "Click CAM 2 in the CAMERA SELECT row. The button lights, and the LCD now reflects CAM 2 — every joystick, zoom, and preset action from now on routes to that camera.",
    matches: (a: PTZAction) => a.kind === "select_cam" && a.target === "cam2",
  },
  {
    id: "recall-lectern",
    body:
      "Recall preset 2 (Lectern) — press the 2 key on the preset pad. The camera snaps to the stored framing for the lectern shot. The LCD's LAST line shows the preset you just recalled.",
    matches: (a: PTZAction) => a.kind === "recall_preset" && a.preset === 2,
  },
  {
    id: "joystick",
    body:
      "Now nudge the joystick (drag it, or use the arrow keys). The active camera pans and tilts live. Try to keep the move small — the audience sees every motion when this camera is on air.",
    matches: (a: PTZAction) => a.kind === "joystick",
  },
  {
    id: "zoom",
    body:
      "Try the zoom rocker (or press +). Zooming is the same as on a still camera — it changes how much of the stage the frame covers. Like the joystick, this happens live on the active camera.",
    matches: (a: PTZAction) => a.kind === "zoom",
  },
  {
    id: "recall-wide",
    body:
      "Last beat: recall preset 1 (Wide). Presets are how you snap the camera back to a known good framing without having to hand-correct it on air. You'll use them constantly during a real session.",
    matches: (a: PTZAction) => a.kind === "recall_preset" && a.preset === 1,
  },
];
